import React, { Fragment } from "react";
import { List, Pagination } from "../..";
import { V2TableRow } from "./TableRow";
import { V2TableHeader } from "./TableHeader";
import { classNames } from "../../utils/classNames";
import { createUseStyles } from "react-jss";
import { TABLE_LIMIT } from "../../layouts/ArticleTable/ArticleTable";
import { V2TableForm } from "./TableForm";
import { TableLoading } from "./TableSkeleton";
import { Scrollable } from "../../Scrollable";
import { useTableContext } from "../../hooks/useTableContext";
import { TableProvider } from "./TableProvider";
import { TableEmpty } from "./TableEmpty";
export function V2Table(props) {
    if (props.form) {
        return (React.createElement(TableProvider, { ...props },
            React.createElement(V2TableForm, { ...props })));
    }
    return (React.createElement(TableProvider, { ...props },
        React.createElement(V2TableWrapper, { ...props },
            React.createElement(V2TableHeader, { ...props }),
            React.createElement(V2TableBody, { ...props }))));
}
export function V2TableWrapper(props) {
    const { children, pagination, childTable } = props;
    const { tableTheme } = useTableContext();
    const classes = useTableClasses(tableTheme, childTable);
    return (React.createElement("div", { style: { position: "relative", color: "" }, className: `${!childTable ? "table-parent" : ""}` },
        !childTable ? (React.createElement(Scrollable, { axis: "x", className: classNames(classes.tableScrollbar) },
            React.createElement(V2TableListComponent, { ...props }, children))) : (React.createElement(V2TableListComponent, { ...props }, children)),
        pagination &&
            pagination.totalRecords &&
            pagination.totalRecords > (pagination.limit || TABLE_LIMIT) ? (React.createElement(Pagination, { offset: pagination.offset, totalRecords: pagination.totalRecords, limit: pagination.limit || TABLE_LIMIT, setOffset: pagination?.setOffset, maxPagesDisplayed: 7, disabled: props.form?.viewState === "edit" })) : null));
}
export function V2TableListComponent(props) {
    const { childTable } = props;
    const { tableWidth, hasAction, tableTheme } = useTableContext();
    const { drawer, headings, children } = props;
    const numberOfColumns = headings.length;
    const classes = useTableClasses(tableTheme, props?.childTable);
    return (React.createElement(List, { className: classNames(classes.table), hover: hasAction, displayStyle: "unset", role: "grid", ariaColCount: drawer || hasAction ? numberOfColumns + 1 : numberOfColumns, ariaRowCount: props.data?.length || props.form?.values[props?.form?.name].length, dataId: props?.dataId, dataTestId: props?.dataTestId, id: props?.id, style: !childTable
            ? { width: tableWidth, position: "unset" }
            : { position: "unset" }, dataHook: childTable ? "child-table" : undefined }, children));
}
export function V2TableBody(props) {
    if (props?.loading) {
        return React.createElement(TableLoading, { ...props });
    }
    let rowIndex = 0;
    return (React.createElement(Fragment, null, props?.data && props?.data?.length > 0 ? (React.createElement(Fragment, null, props?.data?.map((item, i) => {
        rowIndex++;
        return (React.createElement(V2TableRow, { ...props, item: item, key: i, rowIndex: rowIndex }));
    }))) : (React.createElement(TableEmpty, { ...props }))));
}
function useTableClasses(tableStyles, childTable) {
    const { body, header } = tableStyles;
    const useStyles = createUseStyles({
        table: {
            "& .list_row--header-start": header?.borderLeft?.width !== 0
                ? {
                    backgroundColor: `${header?.borderLeft?.color}`,
                }
                : {},
            "& .list_row--header-end": header?.borderRight?.width !== 0
                ? {
                    backgroundColor: `${header?.borderRight?.color}`,
                }
                : {},
            display: "table",
            width: "100%",
            "& .list_row--header-start, .list_row--header-end": {
                position: "absolute",
                top: 0,
                width: !childTable ? 1 : 0,
            },
            borderBottom: !childTable ? body?.borderBottom : {},
        },
        tableScrollbar: {
            borderRight: body?.borderRight,
            borderLeft: body?.borderLeft,
            borderBottomLeftRadius: body?.borderRadiusBottomLeft ?? 0,
            borderBottomRightRadius: body?.borderRadiusBottomRight ?? 0,
        },
    });
    return useStyles();
}
